export default "__VITE_ASSET__DFODrV51__"